import { EventEmitter } from 'events';

import { ProjectService } from './../../../services/project.service';

import { Project } from './../../../classes/project.class';

export class ProjectListPageController extends EventEmitter {
    constructor(params) {
        super();

        this.user = params.user;
        this.service = new ProjectService({apiUrl: params.apiUrl});
        this.projects = [];

        this.service.getProjects(this.user.id).then(response => {
            this.projects = response.data;
            this.emitProjects();
        });
    }

    getProjects() {
        return this.projects;
    }

    createProject() {
        this.service.postProject({}, this.user.id).then(response => {
            if(response.status === 200) {
                this.projects = [];
                this.service.getProjects(this.user.id).then(response => {
                    this.projects = response.data;
                    this.emitProjects();
                });
            }
        });
    }

    updateProject(project) {
        this.service.putProject(project, this.user.id).then(res => {
            this.projects.forEach((project, index) => {
                if(project.id === res.data.id) {
                    this.projects[index] = new Project(res.data);
                }
            });

            this.emitProjects();
        });
    }

    deleteProject(projectId) {
        this.service.deleteProject(projectId, this.user.id).then(response => {
            if(response.status === 200) {
                this.projects = this.projects.filter(project => project.id !== projectId);
                this.emitProjects();
            }
        });
    }

    emitProjects() {
        this.emit('updateProjects');
    }
}


// WEBPACK FOOTER //
// src/pages/project/list/project-list.controller.js